import { useEffect, useRef, useState } from 'react';

//Primereact components
import { Toast } from 'primereact/toast';
import { Toolbar } from 'primereact/toolbar';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { BookAppointmentTabs } from './BookAppointmentTabs';
import { deleteDataWithParameters, getAllDetails, postAllData } from '../../service/ProductService';
import { APPOINTMENT, BOOK_APPOINTMENT_SLOT, UPDATE_APPOINTMENT_SLOT } from '../../config/ApiConstant';
import { bookAppointmentApplication, startTime, endTime, defaultRowOptions, defaultPageRowOptions, Skeletonitems, SkeletonbodyTemplate, paginatorLinks, showingEntries } from '../../appconfig/Settings';
import { formatDate, formatYearMonthDate, getApplicationValue } from '../../appconfig/AppHelper';
import { BookedAppointmentColumns } from '../../appconfig/DatatableSetting';
import { addAppointmentBookingValidate } from '../../config/Validate';

export const BookAppointments = () => {
    document.title = 'Book Appointments | GSPC';

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);
    const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);
    const [globalFilter, setGlobalFilter] = useState<any>(null);

    //Loading/Page Loading
    const [pageLoad, setPageLoad] = useState<boolean>(false);
    const [appointmentList, setAppointmentList] = useState<any>([]);
    const [addUpdateModal, setAddUpdateModal] = useState<boolean>(false);
    const [addUpdateLoader, setAddUpdateLoader] = useState<boolean>(false);
    const [appointmentData, setAppointmentData] = useState<any>({
        bookingDate: new Date(),
        application_type: bookAppointmentApplication[0]
    });
    const [searchData, setSearchData] = useState<any>({
        search_date: new Date(),
        search_application_type: bookAppointmentApplication[0]
    });

    const [deleteModal, setDeleteModal] = useState<boolean>(false);
    const [deleteLoader, setDeleteLoader] = useState<boolean>(false);
    const [deleteId, setDeleteId] = useState<any>(null);
    const [errors, setErrors] = useState<any>({});
    const [btnLoader, setBtnLoader] = useState<boolean>(false);

    //editId
    const [editId, setEditId] = useState<any>(null);

    const [bookedSlots, setBookedSlots] = useState<any>(null);

    // useEffect
    useEffect(() => {
        getAllBookAppointmentList(false);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    //On Input Change
    const onInputSearchChange = (e: any, name: string) => {
        let val;
        if (name === 'search_application_type') {
            val = e;
        } else {
            val = (e.target && e.target.value) || e.value || '';
        }
        setSearchData({ ...searchData, [name]: val });
    };

    // Get all book appointment list
    const getAllBookAppointmentList = async (btnLoaderVal: any) => {
        try {
            setPageLoad(false);
            setBtnLoader(btnLoaderVal);
            const response = await getAllDetails(APPOINTMENT + '?date=' + formatYearMonthDate(searchData?.search_date));
            if (response) {
                const DataList: any = response;
                if (DataList.length === 0) {
                    setAppointmentList([]);
                } else {
                    setAppointmentList(DataList);
                }
                setPageLoad(true);
                setBtnLoader(false);
            } else {
                setBtnLoader(true);
                setPageLoad(false);
                setAppointmentList([]);
            }
        } catch (error: any) {
            setPageLoad(false);
            setAppointmentList([]);
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    // Global search
    const leftToolbarTemplate = () => {
        return (
            <>
                <div className="mr-3">
                    <Calendar value={searchData?.search_date} dateFormat="dd-mm-yy" onChange={(e: any) => onInputSearchChange(e, 'search_date')} showIcon />
                    <small className="p-invalid-txt">{errors['bookingDate']}</small>
                </div>
                {/* <div>
                    <Dropdown
                        value={searchData?.search_application_type}
                        onChange={(e: any) => onInputSearchChange(e.value, 'search_application_type')}
                        options={bookAppointmentApplication}
                        optionLabel="name"
                        placeholder="Select Application type"
                        className={errors['search_application_type'] ? 'p-invalid' : ''}
                    ></Dropdown>
                    <small className="p-invalid-txt">{errors['search_application_type']}</small>
                </div> */}
                <Button label="Search" onClick={() => getAllBookAppointmentList(true)} loading={btnLoader}></Button>
            </>
        );
    };

    // Right toolbar
    const rightToolbarTemplate = () => {
        return (
            <>
                <Button label="Add Appointment" icon="pi pi-plus" onClick={() => openAddUpdateModal()} className="ml-2"></Button>
            </>
        );
    };

    // Template for date
    const dateTemplate = (rowData: any) => {
        return <>{!window.cn(rowData.date) ? formatDate(rowData.date) : ''}</>;
    };

    // Template for application
    const applicationTemplate = (rowData: any) => {
        return <>{getApplicationValue(rowData.app_id)}</>;
    };

    // Template for actions
    const actionsTemplate = (rowData: any) => {
        return (
            <>
                <Button icon="pi pi-pencil" tooltip="Edit" tooltipOptions={{ position: 'top' }} className="p-button mr-2" onClick={() => openUpdateModal(rowData)} />
                <Button icon="pi pi-trash" tooltip="Delete" tooltipOptions={{ position: 'top' }} className="p-button-danger" onClick={() => openDeleteModal(rowData.id)} />
            </>
        );
    };

    //On Input Change
    const onInputChange = (e: any, name: string) => {
        let val;
        if (name == 'slot_start_time' || name == 'slot_end_time' || name == 'application_type') {
            val = e;
        } else {
            val = (e.target && e.target.value) || e.value || '';
        }
        setAppointmentData({ ...appointmentData, [name]: val });
    };

    // Open  update modal
    const openUpdateModal = (rowData: any) => {
        console.log('data', rowData);
        setEditId(rowData?.id);
        setBookedSlots(rowData?.booked_members);

        setAppointmentData({
            ...appointmentData,
            bookingDate: new Date(rowData?.created_at),
            slot_start_time: startTime.find((item) => item.code == rowData?.slot_start_time),
            slot_end_time: startTime.find((item) => item.code == rowData?.slot_end_time),
            application_type: bookAppointmentApplication.find((item) => item.code == rowData?.app_id),
            ava_slots: rowData?.slot_total_members
        });
        setAddUpdateModal(true);
    };

    // Open add update modal
    const openAddUpdateModal = () => {
        setAddUpdateModal(true);
    };

    // Close add update modal
    const closeAddUpdateModal = () => {
        setAppointmentData({
            bookingDate: new Date(),
            application_type: bookAppointmentApplication[0]
        });
        setEditId(null);
        setBookedSlots(null);
        setErrors({});
        setAddUpdateLoader(false);
        setAddUpdateModal(false);
    };

    // Add update api call
    const addUpdateApiCall = async () => {
        try {
            const { errors, isError } = addAppointmentBookingValidate(appointmentData);
            setErrors(errors);

            //Check Error if no errors then call API
            if (!isError) {
                setAddUpdateLoader(true);

                //Request object
                let formData: any = new FormData();
                formData.append('date', formatYearMonthDate(appointmentData.bookingDate));
                formData.append('slot_start_time', appointmentData.slot_start_time.code);
                formData.append('slot_end_time', appointmentData.slot_end_time.code);
                formData.append('ava_slots', appointmentData.ava_slots);
                formData.append('slot_total_members', appointmentData.ava_slots);
                formData.append('app_id', appointmentData.application_type.code);


                if (!window.cn(editId)) {
                    let updateFormData: any = new FormData();
                    updateFormData.append('id', editId);
                    updateFormData.append('slot_total_members', appointmentData.ava_slots);

                    if (appointmentData.ava_slots > bookedSlots) {
                        // apicall
                        const response = await postAllData(UPDATE_APPOINTMENT_SLOT, updateFormData);
                        if (response) {
                            setSearchData({
                                search_date: appointmentData.bookingDate,
                                search_application_type: appointmentData.application_type
                            });
                            setAppointmentData({
                                bookingDate: new Date(),
                                application_type: bookAppointmentApplication[0]
                            });
                            setErrors({});
                            setAddUpdateLoader(false);
                            setAddUpdateModal(false);
                            toast.current?.show({ severity: 'success', summary: 'Success', detail: response?.message });
                            setTimeout(() => {
                                getAllBookAppointmentList(false);
                            }, 1500);
                        }
                    } else {
                        toast.current?.show({ severity: 'error', summary: 'Alert', detail: 'Total slots must be greater than booked slots.' });
                setAddUpdateLoader(false);

                    }
                } else {
                    //apicall
                    const response = await postAllData(BOOK_APPOINTMENT_SLOT, formData);
                    if (response) {
                        setSearchData({
                            search_date: appointmentData.bookingDate,
                            search_application_type: appointmentData.application_type
                        });
                        setAppointmentData({
                            bookingDate: new Date(),
                            application_type: bookAppointmentApplication[0]
                        });
                        setErrors({});
                        setAddUpdateLoader(false);
                        setAddUpdateModal(false);
                        toast.current?.show({ severity: 'success', summary: 'Success', detail: response?.message });
                        setTimeout(() => {
                            getAllBookAppointmentList(false);
                        }, 1500);
                    }
                }
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast

                setAddUpdateLoader(false);
                toast.current?.show({ severity: 'error', summary: 'Alert', detail: 'Something Went Wrong' });
            }
        }
    };

    // Open delete modal
    const openDeleteModal = (id: any) => {
        setDeleteId(id);
        setDeleteModal(true);
    };

    // Close delete modal
    const closeDeleteModal = () => {
        setDeleteId(null);
        setDeleteLoader(false);
        setDeleteModal(false);
    };

    // Delete appointment api call
    const deleteAppointmentApiCall = async () => {
        try {
            setDeleteLoader(true);
            // Delete api call
            const response = await deleteDataWithParameters(APPOINTMENT + '?id=' + deleteId);
            if (response) {
                setDeleteLoader(false);
                setDeleteModal(false);
                setDeleteId(null);
                toast.current?.show({
                    severity: 'success',
                    summary: 'Success',
                    detail: response?.message
                });
                setTimeout(() => {
                    getAllBookAppointmentList(false);
                }, 1500);
            } else {
                toast.current?.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Something went wrong, Please try again.'
                });
                setDeleteLoader(false);
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setDeleteLoader(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Something Went Wrong' });
            }
        }
    };

    return (
        <>
            <BookAppointmentTabs mainTabLabel="Appointment Slots" />

            <Toast ref={toast} />
            <div className="grid crud-demo mt-2">
                <div className="col-12">
                    <div className="card">
                        <Toolbar left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
                        {/* Datatable */}
                        {pageLoad ? (
                            <>
                                <DataTable
                                    value={appointmentList}
                                    showGridlines
                                    stripedRows
                                    globalFilter={globalFilter}
                                    filters={globalFieldFilter}
                                    rows={defaultRowOptions}
                                    paginator={appointmentList.length >= 10 && true}
                                    rowsPerPageOptions={defaultPageRowOptions}
                                    onFilter={(e) => setGlobalFieldFilter(e.filters)}
                                    className="datatable-responsive p-datatable-sm"
                                    emptyMessage="No Appointments Found"
                                    paginatorTemplate={paginatorLinks}
                                    currentPageReportTemplate={showingEntries}
                                >
                                    {BookedAppointmentColumns.map((col, i) => {
                                        if (col.field === 'action') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={actionsTemplate} />;
                                        } else if (col.field === 'date') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={dateTemplate} />;
                                        } else if (col.field === 'app_id') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={applicationTemplate} />;
                                        } else {
                                            return <Column key={col.field} field={col.field} header={col.header} />;
                                        }
                                    })}
                                </DataTable>
                            </>
                        ) : (
                            <>
                                {/* Skeleton Data table */}
                                <DataTable value={Skeletonitems}>
                                    {BookedAppointmentColumns.map((col, i) => (
                                        <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                                    ))}
                                </DataTable>
                            </>
                        )}
                    </div>
                </div>
            </div>

            {/* Add Update Dialog */}
            <Dialog
                visible={addUpdateModal}
                className="p-fluid"
                style={{ width: '100vh' }}
                header={!window.cn(editId) ? 'Edit Appointment Slot' : 'Add Appointment Slot'}
                modal
                footer={
                    <>
                        <Button label="Cancel" icon="pi pi-times" className="p-button-secondary" onClick={closeAddUpdateModal} />
                        <Button label="Submit" icon="pi pi-check" onClick={() => addUpdateApiCall()} loading={addUpdateLoader} />
                    </>
                }
                onHide={closeAddUpdateModal}
            >
                <div className="formgrid grid">
                    <div className="field col-6">
                        <label htmlFor="name">
                            Date <span style={{ color: 'red' }}>*</span>
                        </label>
                        <Calendar
                            value={appointmentData?.bookingDate}
                            dateFormat="dd-mm-yy"
                            onChange={(e: any) => onInputChange(e, 'bookingDate')}
                            minDate={new Date()}
                            showIcon
                            className={errors['bookingDate'] && 'p-invalid'}
                            disabled={!window.cn(editId) ? true : false}
                        />
                        <small className="p-invalid-txt">{errors['bookingDate']}</small>
                    </div>
                    <div className="field col-6">
                        <label htmlFor="name">
                            Application Type <span style={{ color: 'red' }}>*</span>
                        </label>
                        <Dropdown
                            value={appointmentData?.application_type}
                            onChange={(e: any) => onInputChange(e.value, 'application_type')}
                            options={bookAppointmentApplication}
                            optionLabel="name"
                            placeholder="Select Application type"
                            className={errors['application_type'] && 'p-invalid'}
                            disabled={!window.cn(editId) ? true : false}
                        ></Dropdown>
                        <small className="p-invalid-txt">{errors['application_type']}</small>
                    </div>
                    <div className="field col-6">
                        <label htmlFor="name">
                            {!window.cn(editId) ? 'Update Solts' : 'Total Slots'} <span style={{ color: 'red' }}>*</span>
                        </label>
                        <InputText keyfilter="num" value={appointmentData?.ava_slots} name="ava_slots" onChange={(e) => onInputChange(e, 'ava_slots')} id="ava_slots" className={errors['ava_slots'] && 'p-invalid'} />
                        <small className="p-invalid-txt">{errors['ava_slots']}</small>
                    </div>
                    <div className="field col-6">
                        <label htmlFor="name">
                            Time Start <span style={{ color: 'red' }}>*</span>
                        </label>
                        <Dropdown
                            value={appointmentData?.slot_start_time}
                            onChange={(e: any) => onInputChange(e.value, 'slot_start_time')}
                            options={startTime}
                            optionLabel="name"
                            placeholder="Select Start Time"
                            className={errors['slot_start_time'] && 'p-invalid'}
                            disabled={!window.cn(editId) ? true : false}
                        ></Dropdown>
                        <small className="p-invalid-txt">{errors['slot_start_time']}</small>
                    </div>
                    <div className="field col-6">
                        <label htmlFor="name">
                            Time End <span style={{ color: 'red' }}>*</span>
                        </label>
                        <Dropdown
                            value={appointmentData?.slot_end_time}
                            onChange={(e: any) => onInputChange(e.value, 'slot_end_time')}
                            options={endTime}
                            optionLabel="name"
                            placeholder="Select End Time"
                            className={errors['slot_end_time'] && 'p-invalid'}
                            disabled={!window.cn(editId) ? true : false}
                        ></Dropdown>
                        <small className="p-invalid-txt">{errors['slot_end_time']}</small>
                    </div>
                </div>
            </Dialog>

            {/* Delete Dialog */}
            <Dialog
                visible={deleteModal}
                style={{ width: '450px' }}
                header="Delete Appointment"
                modal
                footer={
                    <>
                        <Button label="Cancel" icon="pi pi-times" className="p-button-secondary" onClick={closeDeleteModal} />
                        <Button label="Delete" icon="pi pi-trash" className="p-button-danger" onClick={deleteAppointmentApiCall} loading={deleteLoader} />
                    </>
                }
                onHide={closeDeleteModal}
            >
                <div className="flex align-items-center justify-content-start">
                    <i className="pi pi-exclamation-triangle mr-3 delete-triangle" style={{ fontSize: '2rem' }} />
                    <span className="delete-dialog-note">Note: Once you delete this Appointment, This will be deleted permentatly.</span>
                </div>
            </Dialog>
        </>
    );
};
